module.exports = __webpack_public_path__ + "static/media/tunnel-at-night.5ee3a943.jpg";